'use strict'

const { extract, parse } = require('query-string')
const get_ = require('lodash/get')
const includes_ = require('lodash/includes')
const identity_ = require('lodash/identity')
const { Result, Maybe } = require('@wix/wix-code-adt')

const DEV_QUERY_PARAMS = [
  'ReactSource',
  'EditorSource',
  'experiments',
  'petri_ovr',
  'WixCodeRuntimeSource',
  'js-wixcode-sdk-override',
  'debug'
]

const doesNotContainDevQueryParameter = queryParameters =>
  Object.keys(queryParameters).every(key => !includes_(DEV_QUERY_PARAMS, key))

const forceReport = queryParameters =>
  queryParameters['forceReportSentry'] === 'true'

const getUrlsFromData = data => [
  get_(data, ['request', 'headers', 'Referer']),
  get_(data, ['request', 'url'])
]

const shouldSendReportByUrl = url =>
  Maybe.fromNullable(url)
    .chain(url => Result.try(() => parse(extract(url))))
    .map(
      queryParameters =>
        forceReport(queryParameters) ||
        doesNotContainDevQueryParameter(queryParameters)
    )
    .getOrElse(true)

const shouldSendReportByUrls = data =>
  getUrlsFromData(data).every(shouldSendReportByUrl)

const validators = [shouldSendReportByUrls]

const shouldSendReport = (data, originalCallback = identity_) =>
  validators.concat(originalCallback).every(v => v(data))

module.exports = shouldSendReport
